import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { FormattedMessage } from 'react-intl';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';

const useStyles = makeStyles()((theme) => ({
  container: {
    padding: '48px 20px',
    maxWidth: 520,
    margin: '0 auto',
    textAlign: 'center',
  },
  iconWrapper: {
    width: 80,
    height: 80,
    borderRadius: '50%',
    backgroundColor: theme.palette.error.light,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 24px',
  },
  icon: {
    fontSize: 48,
    color: theme.palette.error.main,
  },
  title: {
    fontSize: theme.typography.pxToRem(22),
    fontWeight: 700,
    fontFamily: 'Ploni, Arial, sans-serif',
    color: theme.palette.secondary.main,
    marginBottom: 12,
  },
  subtitle: {
    fontSize: theme.typography.pxToRem(16),
    fontFamily: 'Ploni, Arial, sans-serif',
    color: theme.palette.text.secondary,
    marginBottom: 24,
  },
  retryBtn: {
    fontWeight: 700,
    fontFamily: 'Ploni, Arial, sans-serif',
    borderRadius: 30,
    padding: '10px 28px',
  },
}));

const ErrorScreen = () => {
  const { classes } = useStyles();

  return (
    <div className={classes.container}>
      <Box className={classes.iconWrapper}>
        <ReportProblemOutlinedIcon className={classes.icon} />
      </Box>
      <Typography className={classes.title}>
        <FormattedMessage id='renewalClick.error.title' />
      </Typography>
      <Typography className={classes.subtitle}>
        <FormattedMessage id='renewalClick.error.subtitle' />
      </Typography>
      <Button
        variant='contained'
        color='primary'
        className={classes.retryBtn}
        onClick={() => window.location.reload()}
      >
        <FormattedMessage id='renewalClick.error.retry' />
      </Button>
    </div>
  );
};

export default ErrorScreen;
